import { ref } from "vue";

const isContactModalOpen = ref(false);

export function useContactModal() {
  const openContactModal = () => {
    isContactModalOpen.value = true;
  };

  const closeContactModal = () => {
    isContactModalOpen.value = false;
  };

  return {
    isContactModalOpen,
    openContactModal,
    closeContactModal,
  };
}
